import type { ContractDatePresetDto, ContractReportQueryDto } from "../../../autogen/bff-api";

export type DateField =
  | "startDate"
  | "endDate"
  | "createdAt"
  | "modifiedAt"
  | "publishedAt"
  | "renewalDate"
  | "terminationDate";

type DatePresets = ContractReportQueryDto["datePresets"];

export const withDatePreset = (
  presets: DatePresets,
  field: DateField,
  preset: ContractDatePresetDto | undefined,
): DatePresets => {
  const next = Object.fromEntries(Object.entries(presets ?? {}).filter(([key]) => key !== field));
  if (preset) next[field] = preset;
  return Object.keys(next).length > 0 ? next : undefined;
};
